import React, { useCallback, useEffect, useMemo } from "react";
import { connect } from "react-redux";

import ConfigSectorsHeader from "./components/ConfigSectorsHeader";
import ConfigSectorsContainer from "./components/ConfigSectorsContainer";
import ConfigSectorsActioner from "../../services/configSectors/actioner";
import ParkkiTheme from "themes/ParkkiTheme";
import styled from "@emotion/styled";

const StyledContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: ${ParkkiTheme.colors.lightGrey};
  margin-bottom: ${ParkkiTheme.spacings.xsmall};
  font-family: "Source Sans Pro", sans-serif;
`;

const ContentContainer = styled.main`
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px ${ParkkiTheme.spacings.tiny} 0;
`;

function ConfigSectors({ contract, initializeModule, mapInitialized }) {
  const contractId = useMemo(() => contract?.id, [contract]);

  const initializeModuleData = useCallback(async () => {
    if (contractId && mapInitialized) {
      await initializeModule();
    }
  }, [contractId, initializeModule, mapInitialized]);

  useEffect(() => {
    setTimeout(initializeModuleData, 200);
  }, [initializeModuleData]);

  return (
    <StyledContainer>
      <div>
        <ContentContainer>
          <>
            <ConfigSectorsHeader />
            <ConfigSectorsContainer />
          </>
        </ContentContainer>
      </div>
    </StyledContainer>
  );
}

const mapStateToProps = (state) => ({
  contract: state.Contract.contract,
  mapInitialized: state.Map.initialized,
});

const mapDispatchToProps = (dispatch) => ({
  initializeModule: () => dispatch(ConfigSectorsActioner.intializeModule()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfigSectors);
